import { Dispatch } from 'redux';

import { setTermValue } from './advanced/term';

export function changeIsFromDeveloper(value?: boolean) {
  return (dispatch: Dispatch) => {
    dispatch(setTermValue('from_developer', value));
  };
}
